<form #form fsForm [submit]="save" *fsSkeletonForm="environmentCreate">
  <mat-card-content>
    <div class="fs-column">
      <h2>Please enter the address of your organization</h2>
      <fs-address-picker
        class="full-width"
        [(address)]="environmentCreate.address"
        [config]="config"
        format="twoline"
      ></fs-address-picker>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button type="submit" mat-raised-button color="primary" class="full-width">Continue</button>
  </mat-card-actions>
</form>
